// extracted by mini-css-extract-plugin
export default {"Box":"table-group-module__Box--F3vEc"};